<!-- measure-details.component.html -->
<div class="measure-details-panel">

  
  <div class="details-content">
    <div class="measure-info-container">
      <div class="measure-identity">
        <div class="info-row">
          <span class="label unselectable">Measure ID:</span>
          <span class="value unselectable">
            <ng-container *ngIf="measure.url; else plainText" >
              <a [href]="measure.url" target="_blank" rel="noopener noreferrer">{{measure.name}}</a>
            </ng-container>
            <ng-template #plainText>{{measure.name}}</ng-template>
          </span>
        </div>
       
        <!--
        <div class="info-row">
          <span class="label">Quality ID:</span>
          <span class="value">{{measure.qualityId}}</span>
        </div>
        -->
        <div class="info-row">
          <span class="label unselectable">Measure:</span>
          <span class="value unselectable">{{measure.measureName}}</span>
        </div>
<br>
        <div>
          <ng-container *ngIf="measure.highPriority"><mat-chip>High Priority</mat-chip></ng-container>
          <ng-container *ngIf="measure.outcome  != ''"><mat-chip class="subChip">Outcome</mat-chip></ng-container>
          <ng-container *ngIf="measure.noBenchmark != ''"><mat-chip class="subChip">No Benchmark</mat-chip></ng-container>
          <ng-container *ngIf="measure.inverse != '' "><mat-chip class="subChip">Inverse</mat-chip></ng-container>
    
          <div *ngIf="measure.floor != '' "><br><br>{{getFloorText(measure.floor || '')}}</div>
         
        </div>
      </div>

      

     
      
      <div class="performance-container">
        <ngx-gauge 
        [value]="getFormatedValue(measure.performance || 0) " 
        [label]="'Performance %'"  
        [append]="''"
        [thick]="15"
        [type]="'full'"
        [margin]="20"
        [foregroundColor]="'#03a9f4'">
      </ngx-gauge>
     
      
      </div>
      
      <div class="points-display">
        <div class="points-value">
          <div class="value unselectable">{{this.getPoints (this.measure.performance  || 0)}}</div>
          <div class="label unselectable">Points</div>
        </div>
      </div>
    </div>

    
    
    <div class="goal-section">
      <div class="goal-header">
        <div class="legend">
          <div class="legend-item">
            <div class="legend-marker last-year"></div>
            <span class="unselectable">Last Year Values</span>
          </div>
          <div class="legend-item">
            <div class="legend-marker current-year"></div>
            <span class="unselectable">Current Year Estimates</span>
          </div>
        </div>
      </div>
    
      <div class="performance-goal">
        <div class="goal-label unselectable">Performance Value/Goal</div>
        <div class="goal-value unselectable">{{getFormatedValue(this.temporaryPerformance || 0)}}%</div>
        <div class="goal-slider">
          <div class="slider-scale">
            <div class="min unselectable">0%</div>
            <div class="max unselectable">100%</div>
          </div>
          <div class="slider-track">
            <div class="marker last-year unselectable" [title]="getFormatedValue(measure.performanceLastYear || 0)" [style.left.%]="getFormatedValue(measure.performanceLastYear || 0)">{{getFormatedValue(measure.performanceLastYear || 0)}}</div>
            <div class="marker current-year"  (mousedown)="startDragging($event)" [title]="getFormatedValue(this.temporaryPerformance || 0)" [style.left.%]="getFormatedValue(this.temporaryPerformance || 0)">{{getFormatedValue(this.temporaryPerformance || 0)}}</div>
          </div>
        </div>
      </div>
    
      <div class="points-goal">
        <div class="goal-label unselectable">Estimated Points/Goal</div>
        <div class="goal-value unselectable">{{this.getPoints(this.temporaryPerformance ||0)}}</div>
        <div class="goal-slider">
          <div class="slider-scale">
            <div class="min unselectable">0pts</div>
            <div class="max unselectable">10pts</div>
          </div>
          <div class="slider-track">
            <div class="marker last-year unselectable" [style.left.%]="getFormattedPoints((measure.pointsLastYear || 0))*10">{{getFormattedPoints((measure.pointsLastYear  ?? 0))}}</div>
         
            <div class="marker current-year" [style.left.%]="getFormattedPoints((this.getPoints(this.temporaryPerformance || 0)) * 10) ">{{getFormattedPoints((this.getPoints(this.temporaryPerformance || 0)))}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
    <div class="calculation-details-container">
      <app-measure-calculation-details
        [ipp]="measure.denominator"
        [denominator]="measure.denominator"
        [denomException]="0"
        [numerator]="measure.numerator"
        [performance]="measure.performance ?? 0">
      </app-measure-calculation-details>
    </div>
</div>
